<angular2-multiselect [data]="dropdownList" [(ngModel)]="selectedItems" [settings]="dropdownSettings"
  (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
  (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/user-selecter/user-selecter.component.html